import { AfterContentInit, Component, ContentChildren, HostBinding, Input, QueryList } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BaseMatControlComponent } from '@rma/generic/ui/forms/base-mat-control';
import { GroupSelectOptionComponent } from './group-select-option/group-select-option.component';

export interface GroupSelectOption {
  label: string;
  value: string;
}

@UntilDestroy()
@Component({
  selector: 'rma-group-select',
  template: `<ng-content />`,
})
export class GroupSelectComponent extends BaseMatControlComponent<string | string[]> implements AfterContentInit {
  @Input()
  multiSelect = false;

  @HostBinding('role')
  role = this.multiSelect ? 'chekbox' : 'radiogroup';

  @ContentChildren(GroupSelectOptionComponent) options!: QueryList<GroupSelectOptionComponent<GroupSelectOption>>;

  public static nextId = 0;
  override id = `rma-group-select${GroupSelectComponent.nextId++}`;

  ngAfterContentInit(): void {
    if (!this.options.length) {
      console.error('you need a rma-group-select component');
      return;
    }

    this.options.forEach((o) => {
      // listen to events
      o.optionChange
        .pipe(untilDestroyed(this))
        .subscribe(({ option, selected }) => this.onSelect(option.value, selected, this.multiSelect));

      o.disabled = this.ngControl.disabled;
    });

    this.updateUI(this.value, this.multiSelect);
  }

  onSelect(value: string, selected: boolean, multiSelect: boolean) {
    if (multiSelect) {
      this.value = Array.isArray(this.value) ? (selected ? [...this.value, value] : this.value.filter((v) => v !== value)) : [value];
    } else {
      this.value = selected ? value : null;
    }

    this.handleInput();
    this.updateUI(this.value, multiSelect);
  }

  private updateUI(value: string | string[] | null, multiSelect: boolean) {
    this.options.forEach((o) => (o.selected = multiSelect ? (this.value?.includes(o.option.value) ?? false) : o.option.value === value));
  }
}
